"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UICheckbox = _interopRequireDefault(require("../input/UICheckbox"));

var _UIRadioInput = _interopRequireDefault(require("../input/UIRadioInput"));

var _underscore = require("../utils/underscore");

var _DomEvents = require("../utils/DomEvents");

var _ActiveProvider = _interopRequireDefault(require("../providers/ActiveProvider"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _decorators = require("../utils/propTypes/decorators");

var UISelectableBox =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UISelectableBox, _Component);

  function UISelectableBox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UISelectableBox);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UISelectableBox).call(this, props));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onSelectedChange = _this$props.onSelectedChange,
          selected = _this$props.selected,
          type = _this$props.type,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }

      if (type !== 'radio') {
        onSelectedChange((0, _SyntheticEvent.default)(!selected));
      }

      if (onClick) onClick(evt);
    };

    _this.handleKeyPress = function (evt) {
      if (evt.target.type === 'checkbox') return;
      var key = evt.key; // treat enter or space key like a click event

      if (key === 'Enter' || key === ' ') {
        evt.preventDefault();

        _this.handleClick();
      }
    };

    _this._id = (0, _underscore.uniqueId)('bsb-');
    return _this;
  }

  (0, _createClass2.default)(UISelectableBox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          __active = _this$props2.active,
          block = _this$props2.block,
          children = _this$props2.children,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          flush = _this$props2.flush,
          height = _this$props2.height,
          __hovered = _this$props2.hovered,
          innerClassName = _this$props2.innerClassName,
          name = _this$props2.name,
          __onClick = _this$props2.onClick,
          __onSelectedChange = _this$props2.onSelectedChange,
          padded = _this$props2.padded,
          readOnly = _this$props2.readOnly,
          selected = _this$props2.selected,
          selectionMarkLocation = _this$props2.selectionMarkLocation,
          tabIndex = _this$props2.tabIndex,
          type = _this$props2.type,
          width = _this$props2.width,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["active", "block", "children", "className", "disabled", "flush", "height", "hovered", "innerClassName", "name", "onClick", "onSelectedChange", "padded", "readOnly", "selected", "selectionMarkLocation", "tabIndex", "type", "width"]);
      return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
        return _react.default.createElement(_ActiveProvider.default, _this2.props, function (activeProviderProps) {
          var active = activeProviderProps.active,
              activeProviderRestProps = (0, _objectWithoutProperties2.default)(activeProviderProps, ["active"]);
          var hovered = hoverProviderProps.hovered,
              hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
          var computedClassName = (0, _classnames.default)('uiButton', 'private-button', 'private-selectable-box', {
            'private-button--active': active,
            'private-selectable-box--selected': selected,
            'private-button--block': block,
            'disabled private-button--disabled': disabled,
            'private-selectable-box--hovered': hovered && !disabled && !readOnly,
            'private-selectable-box--padded': padded,
            'private-selectable-box--flush': flush,
            'private-selectable-box--readonly': readOnly
          }, className);
          var renderedSelectionMark = null;

          if (type !== 'default') {
            var selectionMarkClassname = (0, _classnames.default)('private-selectable-box__selection-mark', {
              'private-selectable-box__selection-mark--left': selectionMarkLocation === 'left',
              'private-selectable-box__selection-mark--top-right': selectionMarkLocation === 'top-right'
            });

            if (type === 'checkbox') {
              renderedSelectionMark = _react.default.createElement("div", {
                className: selectionMarkClassname
              }, _react.default.createElement(_UICheckbox.default, {
                "aria-labelledby": _this2._id,
                checked: selected,
                disabled: disabled,
                innerPadding: "none",
                name: name,
                onChange: _this2.handleClick,
                onClick: _DomEvents.stopPropagationHandler,
                readOnly: readOnly
              }));
            }

            if (type === 'radio') {
              if (!name) {
                _devLogger.default.warn({
                  message: 'UISelectableBox: If type is set to radio you must provide a name',
                  key: 'UISelectableBox: no name value'
                });
              }

              renderedSelectionMark = _react.default.createElement("div", {
                className: selectionMarkClassname
              }, _react.default.createElement(_UIRadioInput.default, {
                "aria-labelledby": _this2._id,
                checked: selected,
                disabled: disabled,
                name: name,
                onChange: _this2.handleClick,
                onClick: _DomEvents.stopPropagationHandler,
                readOnly: readOnly
              }));
            }
          }

          var tabbableByDefault = !disabled && type === 'default';
          var defaultTabIndex = tabbableByDefault ? 0 : null;
          return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
            _react.default.createElement("div", (0, _extends2.default)({}, rest, activeProviderRestProps, hoverProviderRestProps, {
              "aria-checked": selected,
              "aria-disabled": disabled,
              className: computedClassName,
              onClick: _this2.handleClick,
              onKeyPress: _this2.handleKeyPress,
              role: type === 'radio' ? 'radio' : 'checkbox',
              tabIndex: typeof tabIndex === 'number' ? tabIndex : defaultTabIndex
            }), renderedSelectionMark, _react.default.createElement("div", {
              className: (0, _classnames.default)('private-selectable-box__inner', innerClassName),
              id: _this2._id,
              style: {
                height: height,
                width: width
              }
            }, children))
          );
        });
      });
    }
  }]);
  return UISelectableBox;
}(_react.Component);

UISelectableBox.propTypes = {
  active: (0, _decorators.hidden)(_propTypes.default.bool),
  'aria-checked': _propTypes.default.bool,
  block: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  flush: _propTypes.default.bool,
  height: _propTypes.default.number,
  hovered: (0, _decorators.hidden)(_propTypes.default.bool),
  innerClassName: _propTypes.default.string,
  name: _propTypes.default.string,
  onSelectedChange: _propTypes.default.func,
  padded: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  selectionMarkLocation: _propTypes.default.oneOf(['left', 'top-right']),
  type: _propTypes.default.oneOf(['default', 'checkbox', 'radio']).isRequired,
  width: _propTypes.default.number
};
UISelectableBox.defaultProps = {
  disabled: false,
  padded: true,
  readOnly: false,
  selected: false,
  type: 'default'
};
UISelectableBox.displayName = 'UISelectableBox';

var _default = (0, _Controllable.default)(UISelectableBox, ['selected']);

exports.default = _default;
module.exports = exports.default;